import {ArticlesContainer} from '../containers/ArticlesContainer/index'

export const ArticlesPage = () => (
    <>
        <ArticlesContainer/>
    </>
)